import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: `users`,
    initialState: {
        businessList: {
            pagination: {},
            isStarted: false,
            isError: false,
            error: '',
            value: [],
        },
        businessStats: {
            isStarted: false,
            isError: false,
            error: '',
            value: [],
        },
        updateBusiness: {
            isStarted: false,
            isError: false,
            error: '',
            value: ''
        },
    },
    reducers: {    
        isStarted_GetBusinessList: (state) => {
            state.businessList.isStarted = true;
            state.businessList.isError = false;
        },
        success_GetBusinessList: (state, action) => {
            console.log("success_GetUserProfile: ",action)
            let { payload, pagination } = action.payload;
            state.businessList.isError = false;
            state.businessList.isStarted = false;
            state.businessList.error = '';
            state.businessList.pagination = pagination;
            state.businessList.value = payload;
        },
        error_GetBusinessList: (state, action) => {
            let { payload } = action;
            state.businessList.isError = true;
            state.businessList.isStarted = false;
            state.businessList.hasLoadedValue = false;
            state.businessList.error = payload;
            //state.GetUserProfile.value = payload;
        },
        isStarted_GetBusinessStats: (state) => {
            state.businessStats.isStarted = true;
            state.businessStats.isError = false;
        },
        reset_GetBusinessStats: (state) => {
            // console.log("reset_GetbusinessStats: ")
            state.businessStats.isStarted = false;
            state.businessStats.isError = false;
            state.businessStats.value = [];
            state.businessStats.error = '';
        },
        success_GetBusinessStats: (state, action) => {
            //console.log("success_businessStats: ",action)
            let { payload } = action;
            state.businessStats.isError = false;
            state.businessStats.isStarted = false;
            state.businessStats.error = '';
            state.businessStats.hasLoadedValue = true;
            state.businessStats.value = payload;
        },
        error_GetBusinessStats: (state, action) => {
            let { payload } = action;
            state.businessStats.isError = true;
            state.businessStats.isStarted = false;
            state.businessStats.hasLoadedValue = false;
            state.businessStats.error = payload;
        },
        isStarted_UpdateBusiness: (state) => {
            // console.log("isStarted_UpdateComment: ")
            state.updateBusiness.isStarted = true;
            state.updateBusiness.isError = false;
            state.updateBusiness.isSuccess = false;
        },
        reset_UpdateBusiness: (state) => {
            // console.log("reset_UpdateBusiness: ")
            state.updateBusiness.isStarted = false;
            state.updateBusiness.isError = false;
            state.updateBusiness.isSuccess = false;
            state.updateBusiness.value = '';
            state.updateBusiness.error = '';
        },
        success_UpdateBusiness: (state, action) => {
            // console.log("success_updateBusiness: ",action)
            let { payload } = action;
            state.updateBusiness.isError = false;
            state.updateBusiness.isStarted = false;
            state.updateBusiness.isSuccess = true;
            state.updateBusiness.error = '';
            state.updateBusiness.value = payload;
        },
        error_UpdateBusiness: (state, action) => {
            // console.log("error_UpdateBusiness: ",action)
            let { payload } = action;
            state.updateBusiness.isError = true;
            state.updateBusiness.isStarted = false;
            state.updateBusiness.error = payload;
            state.updateBusiness.value = '';
        }
    }
})

export const {    
    isStarted_GetBusinessList, success_GetBusinessList, error_GetBusinessList,
    isStarted_GetBusinessStats, success_GetBusinessStats, error_GetBusinessStats,reset_GetBusinessStats,
    isStarted_UpdateBusiness, success_UpdateBusiness, error_UpdateBusiness,reset_UpdateBusiness
} = userSlice.actions
export default userSlice.reducer